import { useTranslation } from 'react-i18next';

import { ReactComponent as ClientIcon } from '../../../../../../assets/icons/icon-client.svg';
import { ReactComponent as SearchIcon } from '../../../../../../assets/icons/search.svg';
import { ReactComponent as WarningIcon } from '../../../../../../assets/icons/warning.svg';
import CustomButton from '../../../../../../shared/components/Buttons/CustomButton/CustomButton';
import EmptyState from '../../../../../../shared/components/Globals/EmptyState/EmptyState';
import type { IClientsTableStateProps } from '../../../../../../shared/interfaces/clients';
import { TRANSLATIONS_CLIENTS } from '../../../../../../shared/translations/clients';
import { ClientsStatus } from '../../../../../../shared/types/clients';

import './ClientsTableState.scss';

const STATES = TRANSLATIONS_CLIENTS.clientsList.states;
const ICON_SIZE = 22;

const ClientsTableState = ({ status, query, error, onRetry }: IClientsTableStateProps) => {
  const { t } = useTranslation();

  if (error) {
    return (
      <EmptyState
        className="clients-table-state clients-table-state--error"
        icon={<WarningIcon width={ICON_SIZE} height={ICON_SIZE} aria-hidden="true" />}
        title={t(STATES.error.title)}
        description={t(STATES.error.description)}
      >
        <CustomButton variant="default" size="s" onClick={onRetry}>
          {t(STATES.error.retry)}
        </CustomButton>
      </EmptyState>
    );
  }

  if (query.trim()) {
    return (
      <EmptyState
        className="clients-table-state"
        icon={<SearchIcon width={ICON_SIZE} height={ICON_SIZE} aria-hidden="true" />}
        title={t(STATES.noResults.title, { query: query.trim() })}
        description={t(STATES.noResults.description)}
      />
    );
  }

  const statusCopy = status === ClientsStatus.AwaitingStart ? STATES.noAwaitingStart : STATES.noActive;

  return (
    <EmptyState
      className="clients-table-state"
      icon={<ClientIcon width={ICON_SIZE} height={ICON_SIZE} aria-hidden="true" />}
      title={t(statusCopy.title)}
      description={t(statusCopy.description)}
    />
  );
};

export default ClientsTableState;
